module.exports = __webpack_public_path__ + "img/book-open-02.320c27c0.svg";